import React from "react";
import BoxLoader from "../commons/BoxLoader/BoxLoader";

type AppProps = {
  data: any;
  handleToggleProbationModal: () => void;
  fetching: boolean;
};
const EmployeeOnProbation = ({
  data,
  handleToggleProbationModal,
  fetching,
}: AppProps) => {
  return (
    <div className="boxs p-3" style={{ height: "150px" }}>
      {fetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div>
            <div className="mb-3" style={{ fontWeight: 600, fontSize: "16px" }}>
              Employee on Probation
            </div>
          </div>
          <div className="mb-1 d-flex justify-content-between align-items-center">
            <div style={{ fontWeight: 500, fontSize: "32px" }}>
              {data?.total_count}
            </div>
            <div>
              <button
                onClick={handleToggleProbationModal}
                className="btn"
                style={{ color: "#dd4433" }}
                disabled={data?.total_count === 0}
              >
                View All
              </button>
            </div>
          </div>
          <div style={{ color: "#6e7491" }}>Employee on Probation Period</div>
        </>
      )}
    </div>
  );
};

export default EmployeeOnProbation;
